import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "sonner";
import axios from "axios";
import { API } from "../config";

export default function UnsubscribeForm() {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            const r = await axios.post(`${API}/unsubscribe/request`, { email });
            toast.success("Check your inbox.", {
                description:
                    r.data.message ||
                    "If that email is on our list, we've sent an unsubscribe link.",
            });
            setEmail("");
            setOpen(false);
        } catch {
            toast.error("Signal lost.", { description: "Try again in a moment." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col items-start gap-3" data-testid="unsubscribe-widget">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                data-testid="unsubscribe-toggle-btn"
                className="text-[10px] tracking-[0.25em] uppercase text-[#8F909A] hover:text-[#FF2B56] underline underline-offset-4 transition-colors duration-300"
            >
                Unsubscribe
            </button>

            <AnimatePresence initial={false}>
                {open && (
                    <motion.form
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.3 }}
                        onSubmit={submit}
                        className="flex flex-col sm:flex-row gap-2 overflow-hidden"
                        data-testid="unsubscribe-form"
                    >
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="YOUR@EMAIL.COM"
                            data-testid="unsubscribe-email-input"
                            className="bg-[#08080A] border border-[#22222B] focus:border-[#FF2B56] outline-none px-4 py-2.5 text-[11px] tracking-widest uppercase placeholder:text-[#8F909A]/50 transition-colors duration-300 min-w-[220px]"
                        />
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="unsubscribe-submit-btn"
                            className="border border-[#FF2B56]/50 text-[#FF2B56] hover:bg-[#FF2B56] hover:text-[#08080A] font-display font-bold text-[11px] tracking-widest uppercase px-5 py-2.5 clip-corner-sm disabled:opacity-60 transition-colors duration-300"
                        >
                            {loading ? "Sending..." : "Send link"}
                        </button>
                    </motion.form>
                )}
            </AnimatePresence>
        </div>
    );
}
